import _ from 'lodash';

class AuthenticationService {

  constructor(ConstantsService, $http, $rootScope, $location, $state, $window) {
    "ngInject";
    this.$http = $http;
    this.$location = $location;
    this.loginPath = './login';
    this.user = undefined;
    this.loginErrorMessage = undefined;
    this.$rootScope = $rootScope;
  }

  hasRole(role) {
    if(this.user) {
        return _.find(this.user.roles, ['roleName', role]) !== undefined;
    }
  }

  hasPermission(permissionName) {
    let hasPermission = false;

    if(this.user) {
      this.user.roles.forEach(function (role) {
        role.permissions.forEach(function (permission) {
          if (permission.name === permissionName) {
            hasPermission = true;
          }
        });
      });
    }

    return hasPermission;
  }


  hasTrackLeave() {
    return this.user.trackLeave;
  }

  hasOneOfTheseRoles(roles) {
    let result = false;
    if(this.user) {
      roles.forEach(function (role) {
        let found = false;
        found = _.find(this.user.roles, ['roleName', role]) !== undefined;
        if(found) {
          result = true;
        }
      });
    }

    return result;
  }


  logout() {
    let as = this;
    this.logoutPath = this.$rootScope.apiHost+'/api/logout';
    
    // Clear user state immediately since 303 redirects may cause browser navigation
    as.user = undefined;
    
    this.$http.get(this.logoutPath, {withCredentials: true})
      .then(function(response) {
        // If redirect was followed and we got a response, navigate to login
        if (response.status >= 200 && response.status < 300) {
          as.$location.path('/login');
        }
      })
      .catch(function(response) {
        // Handle redirect responses (303, 302, 301) or other errors
        // For 303 redirects, the browser may have already navigated
        // If not, navigate to login
        if (response.status !== 0) { // Status 0 usually means request was cancelled due to navigation
          as.$location.path('/login');
        }
      });
  }

  isAuthenticated() {
    return this.$http.get(this.$rootScope.apiHost+'/api/login/authenticated', {withCredentials: true});
  }

  loadUserAfterAuth() {
    return this.$http.get(this.$rootScope.apiHost+"/api/users/me",{withCredentials: true} );
  }


  authenticateBasic(credentials) {
    let headers = {};

    if(credentials && credentials.username) {
      headers.authorization = "Basic " + btoa(credentials.username + ":" + credentials.password);
    }

    return this.$http.get(this.$rootScope.apiHost+"/api/oauth/authorize",{headers:headers, withCredentials: true} );
  }

  loadUser() {
    let self = this;
    return this.$http.get(this.$rootScope.apiHost+"/api/users/me", {withCredentials: true})
      .then(
        function(response) {
          self.setUserData(response.data);
          console.log('user loaded');
          return self.user; // Return the user data so await can receive it
        },
        function(response) {
          console.error('Failed to load user:', response);
          // $state.go('login');
          return undefined;
        }
      );
  }


  // loadUser(){
  //     let self = this;
  //     return this.$http.get(this.$rootScope.apiHost+"/api/users/me",{withCredentials: true} ).then(
  //       function(response) {
  //         // self.user = response.data;
  //         // self.$rootScope.user = self.user;
  //         self.setUserData(response.data);
  //         console.log('user loaded');
  //       },
  //       function(response) {
  //         self.user = undefined;
  //     });
  // }


  refreshUser() {
    let self = this;
    return this.$http.get(this.$rootScope.apiHost+"/api/users/me",{withCredentials: true} ).then(
      function(response) {
        // self.user = response.data;
        self.setUserData(response.data)
      });
  }

  setUserData(data) {
    this.user = data

    let ete = 0;
    let peiy = 0;
    if(this.user.errantTimeEntry) {
      ete = this.user.errantTimeEntry.percentErrantInPayPeriod;
      peiy =  this.user.errantTimeEntry.percentErrantInYear
    }

    this.user.onTimeRate = {
      current: 100 - ete,
      year: 100 - peiy,
    }

    this.$rootScope.user = this.user
  }

  getUser() {
    return self.user;
  }

}

export default AuthenticationService;



// WEBPACK FOOTER //
// ./client/common/services/authentication/authentication.service.js